import React, { useEffect, useState } from "react";
import { useCreateOrEditOrderMutation, useDeclareOrderMutation } from "../store/api/orderApi";
import "./order.css";
import {
  useGetCountriesQuery,
  useGetCurrenciesQuery,
  useGetRecipientsQuery,
  useGetCategoriesQuery,
} from "../store/api/recipientApi";
import TextField from "../components/TextField";
import SelectField from "../components/MySelect";
import FileUpload from "../components/FileUpload";
import {
  FaFileUpload
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import Button from "../components/Button";
import { useTutorial } from "../hooks/useTutorial";
import TutorialModal from "../components/TutorialModal";
import QuestionHint from "../components/QuestionHint";

const OrderDeclare = () => {
  const {
    data: currency,
    error: currencyError,
    isLoading: isLoadingCurrency,
  } = useGetCurrenciesQuery();
  const {
    data: category = [],
    error: categoryError,
    isLoading: isLoadingCategory,
  } = useGetCategoriesQuery();
  const location = useLocation();
  const order = location.state;
  const [seccesscreate, setSeccessCreate] = useState(false);
  const tutorial = useTutorial("create_orders");
  const [form, setForm] = useState({

  });

  const [inputErrors, setInputErrors] = useState({});

  const [createOrEditOrder, { isLoading }] = useDeclareOrderMutation();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({
        ...prev,
        invoiceFile: {
          uri: URL.createObjectURL(file),
          name: file.name,
          type: file.type,
          raw: file,
        },
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};

    if (Object.keys(errors).length > 0) {
      setInputErrors(errors);
      return;
    }

    if (!form.guid) return

    const formData = new FormData();
    formData.append("amount", form.amount);
    formData.append("shop", form.shop);
    formData.append("description", form.description);
    formData.append("order_guid", form.guid);
    formData.append("currency_guid", form.currency_guid);
    formData.append("category_guid", form.category_guid);
    if (form.invoiceFile?.raw) {
      formData.append("invoice", form.invoiceFile.raw);
    }

    try {
      await createOrEditOrder(formData).unwrap();
      setSeccessCreate((state) => true);
    } catch (err) {
      console.error(err);
      alert("❌ Ошибка при создании заказа.");
    }
  };

  useEffect(() => {
    setForm(state => ({ ...order }))
  }, [order])

  return (
    <div className="ordform-container">
      {/* <TutorialModal
        isOpen={tutorial.isOpen}
        onClose={tutorial.onClose}
        title="2 этап"
        description="Здесь вы можете посмотреть актуальные заказы а так же историю ваших заказов для удобства в навигации рекомендуем вам использовать фильтры."
      /> */}

      <TutorialModal
        isOpen={seccesscreate}
        onClose={() => {
          setSeccessCreate((state) => !state);
        }}
        title="Заказ успешно задекларирован"
        description=""
      >
        <img src="success.png" alt="" />
      </TutorialModal>
      <h2 className="ordform-header">
        Декларирование{" "}
      </h2>
      <form onSubmit={handleSubmit} className="ordform-space">

        <div className="ordform-group">
          {isLoadingCurrency ? (
            <div className="ordform-loading">Загрузка...</div>
          ) : currencyError ? (
            <div className="ordform-error">Ошибка загрузки</div>
          ) : (
            <SelectField
              label="Валюта"
              value={form.currency_guid}
              onChange={(e) =>
                setForm({
                  ...form,
                  currency_guid: e.target.value,
                })
              }
              placeholder="Выберите валюту"
              options={currency.map((c) => ({
                value: c.guid,
                label: c.name,
              }))}
              defaultValue=""
              error={inputErrors?.currency_guid}
            />
          )}
        </div>

        <div className="ordform-group">
          {isLoadingCategory ? (
            <div className="ordform-loading">Загрузка...</div>
          ) : categoryError ? (
            <div className="ordform-error">Ошибка загрузки</div>
          ) : (
            <SelectField
              label="Категория"
              value={form.category_guid}
              onChange={(e) =>
                setForm({
                  ...form,
                  category_guid: e.target.value,
                })
              }
              placeholder="Выберите категорию"
              options={category.map((c) => ({
                value: c.guid,
                label: c.name,
              }))}
              defaultValue=""
              error={inputErrors?.category_guid}
            />
          )}
        </div>

        <div className="ordform-group">
          <TextField
            label="Стоимость"
            type="number"
            value={form.amount}
            onChange={(e) => setForm({ ...form, amount: e.target.value })}
            placeholder="1000"
            error={inputErrors?.cost}
          />
        </div>

        <div className="ordform-group">
          <TextField
            label="Магазин"
            type="text"
            value={form.shop}
            onChange={(e) => setForm({ ...form, shop: e.target.value })}
            placeholder="Amazon, eBay..."
            error={inputErrors?.shop}
          />
        </div>

        {/* <div className="ordform-group">
          <TextField
            label="Ссылка на товар"
            type="text"
            value={form.linkOrder}
            onChange={(e) => setForm({ ...form, linkOrder: e.target.value })}
            placeholder="https:"
            error={inputErrors?.linkOrder}
          />
        </div> */}

        <div className="ordform-group">
          <FileUpload
            label="Файл инвойса"
            icon={<FaFileUpload />}
            error={inputErrors.invoiceFile}
            onChange={handleFileChange}
          />
        </div>
        <div className="ordform-group" style={{ width: "100%" }}>
          <label className="ordform-label">Комментарий/описание</label>
          <textarea
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            className="ordform-textarea"
            placeholder="Комментарий к заказу"
          ></textarea>
        </div>

        <div className="personal-bottom">
          <Button type="submit">Подтвердить</Button>
        </div>
      </form>
    </div>
  );
};

export default OrderDeclare;
